/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { brandingsDestroy } from '../../axios/brandingsDestroy'
import type {
	BrandingsDestroyError,
	BrandingsDestroyPathParams,
	BrandingsDestroyResponse,
} from '../../types/BrandingsDestroy'

export const brandingsDestroyMutationKey = () => [{ url: '/brandings/:branding' }] as const

export type BrandingsDestroyMutationKey = ReturnType<typeof brandingsDestroyMutationKey>

export type BrandingsDestroyVariables = {
	branding: BrandingsDestroyPathParams['branding']
}

/** @see backend/nexus/modules/Branding/Http/Controllers/BrandingController.php BrandingController::destroy */
export function useBrandingsDestroy<TContext = unknown>(
	options?: UseMutationOptions<
		BrandingsDestroyResponse,
		AxiosError<BrandingsDestroyError>,
		BrandingsDestroyVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: brandingsDestroyMutationKey(),
		mutationFn: ({ branding }: BrandingsDestroyVariables) =>
			brandingsDestroy(branding, config).then(res => res.data),
		...options,
	})
}
